import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

type CuitTextFieldProps = Omit<TextFieldProps, 'onChange' | 'value'> & {
  value: string;
  onChange: (value: string) => void;
};

const formatCuit = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, 11);

  if (digits.length <= 2) {
    return digits;
  }

  if (digits.length <= 10) {
    return `${digits.slice(0, 2)}-${digits.slice(2)}`;
  }

  return `${digits.slice(0, 2)}-${digits.slice(2, 10)}-${digits.slice(10)}`;
};

export const isValidCuitFormat = (value: string): boolean => {
  return /^\d{2}-\d{8}-\d{1}$/.test(value);
};

const CuitTextField: React.FC<CuitTextFieldProps> = ({
  value,
  onChange,
  label = 'CUIT',
  placeholder = 'XX-XXXXXXXX-X',
  ...props
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(formatCuit(event.target.value));
  };

  return (
    <TextField
      fullWidth
      label={label}
      variant="filled"
      type="text"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      inputProps={{
        maxLength: 13,
        inputMode: 'numeric',
        ...props.inputProps,
      }}
      {...props}
    />
  );
};

export default CuitTextField;
